import defaultProps from 'recompose/defaultProps';
import { Loader } from 'travelopod-components';

export default defaultProps({
  centered: true,
})(Loader);
